<div (click)="cta()"
      title="{{ 'BUTTON.EXPORT' | translate }}">
    {{ "BUTTON.EXPORT" | translate }}&nbsp;
    <aa-icon-circle class="grey"
                    [faIcon]="'fas fa-arrow-to-bottom'">
    </aa-icon-circle>
</div>
